import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
interface Props {
  variation: 'white' | 'green';
  size?: string | number;
  className?: string;
}
const CloseIcon: FC<Props> = t0 => {
  const $ = _c(7);
  const {
    variation: t1,
    size: t2,
    className
  } = t0;
  const variation = t1 === undefined ? "white" : t1;
  const size = t2 === undefined ? 14 : t2;
  const t3 = variation === "white" ? "#fff" : "#39F500";
  const t4 = variation === "white" ? "#fff" : "#39F500";
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = <path d="M7.00072 7.70774L1.75472 12.9537C1.66139 13.0471 1.54672 13.0971 1.41072 13.1037C1.27472 13.1104 1.15339 13.0604 1.04672 12.9537C0.940052 12.8471 0.886719 12.7291 0.886719 12.5997C0.886719 12.4704 0.940052 12.3524 1.04672 12.2457L6.29272 6.99974L1.04672 1.75374C0.953385 1.66041 0.903385 1.54574 0.896719 1.40974C0.890052 1.27374 0.940052 1.15241 1.04672 1.04574C1.15339 0.939075 1.27139 0.885742 1.40072 0.885742C1.53005 0.885742 1.64805 0.939075 1.75472 1.04574L7.00072 6.29174L12.2467 1.04574C12.3401 0.952409 12.4551 0.902409 12.5917 0.895742C12.7271 0.889075 12.8481 0.939075 12.9547 1.04574C13.0614 1.15241 13.1147 1.27041 13.1147 1.39974C13.1147 1.52908 13.0614 1.64708 12.9547 1.75374L7.70872 6.99974L12.9547 12.2457C13.0481 12.3391 13.0981 12.4541 13.1047 12.5907C13.1114 12.7261 13.0614 12.8471 12.9547 12.9537C12.8481 13.0604 12.7301 13.1137 12.6007 13.1137C12.4714 13.1137 12.3534 13.0604 12.2467 12.9537L7.00072 7.70774Z" stroke={t3} fill={t4} />;
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== className || $[4] !== size || $[5] !== t5) {
    t6 = <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 14 14" fill="none" className={className}>{t5}</svg>;
    $[3] = className;
    $[4] = size;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default CloseIcon;